"use strict";

module.exports = /*@ngInject*/function () {
  return function (object) {
    if (!object) return object;
    var address = '';
    if (object.street) {
      address += object.street ? object.street : '';
    } else {
      address += object.address ? object.address : '';
      address += object.address2 ? " ".concat(object.address2) : '';
    }
    address += object.city ? " ".concat(object.city, ", ") : '';
    address += object.state ? " ".concat(object.state, " ") : '';
    if (object.postalCode) {
      address += object.postalCode ? " ".concat(object.postalCode) : '';
    } else {
      address += object.zip ? " ".concat(object.zip) : '';
    }
    return address.trim();
  };
};